module.exports = __webpack_public_path__ + "img/wifi5.6cf6467e.gif";